import { LinkTo } from '@ember/routing';
import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import MobileHeader from './mobile-header.gts';

interface Signature {
  Args: {
    title?: string;
    backRoute?: string;
    backLabel?: string;
  };
}

const PageLoading: TOC<Signature> = <template>
  {{#if @title}}
    <MobileHeader @title={{@title}} />
  {{/if}}

  {{#if @backRoute}}
    <div class="mb-4">
      <LinkTo @route={{@backRoute}} class="btn btn-ghost btn-sm gap-1">
        &larr;
        {{or @backLabel "Back"}}
      </LinkTo>
    </div>
  {{/if}}

  {{#if @title}}
    <h1 class="mb-6 hidden text-3xl font-bold lg:block">{{@title}}</h1>
  {{/if}}

  <div class="bg-base-100 rounded-box mb-4 p-6 shadow">
    <div class="skeleton mb-3 h-9 w-2/3"></div>
    <div class="flex gap-2">
      <div class="skeleton h-6 w-20"></div>
      <div class="skeleton h-6 w-16"></div>
      <div class="skeleton h-6 w-24"></div>
    </div>
  </div>

  <div class="bg-base-100 rounded-box mb-4 p-6 shadow">
    <div class="skeleton mb-3 h-6 w-40"></div>
    <div class="skeleton mb-2 h-4 w-full"></div>
    <div class="skeleton mb-2 h-4 w-5/6"></div>
    <div class="skeleton h-4 w-2/3"></div>
  </div>

  <div class="mt-8 flex flex-col gap-4">
    <div class="bg-base-100 rounded-box p-5 shadow">
      <div class="skeleton mb-3 h-5 w-56"></div>
      <div class="skeleton mb-2 h-4 w-full"></div>
      <div class="skeleton h-4 w-4/5"></div>
    </div>
    <div class="bg-base-100 rounded-box p-5 shadow">
      <div class="skeleton mb-3 h-5 w-48"></div>
      <div class="skeleton mb-2 h-4 w-full"></div>
      <div class="skeleton h-4 w-3/4"></div>
    </div>
  </div>
</template>;

export default PageLoading;
